var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1283_1571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.49858 16C4.0891 16 0.5 12.4109 0.5 7.99858C0.5 3.58626 4.0891 0 8.49858 0C12.908 0 16.4972 3.5891 16.4972 7.99858C16.4972 12.408 12.908 15.9972 8.49858 15.9972V16ZM8.49858 0.569699C4.40244 0.569699 1.0697 3.90244 1.0697 7.99858C1.0697 12.0947 4.40244 15.4275 8.49858 15.4275C12.5947 15.4275 15.9275 12.0947 15.9275 7.99858C15.9275 3.90244 12.5976 0.569699 8.49858 0.569699Z",
    fill: "#34C759"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1283_1571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.3051 9.99995C7.18782 9.92092 7.05955 9.85268 6.96059 9.75569C6.35955 9.17739 5.76583 8.58831 5.16845 8.00641C5.02552 7.86992 4.96688 7.70469 5.02185 7.51431C5.07682 7.32753 5.21243 7.209 5.40667 7.16589C5.59724 7.12279 5.74751 7.19822 5.87944 7.32753C6.35588 7.79449 6.82866 8.25785 7.3051 8.7248C7.33442 8.75354 7.3674 8.78227 7.42237 8.83256C7.45169 8.78946 7.47368 8.74635 7.50667 8.71762C8.70876 7.53946 9.91086 6.3613 11.1129 5.18314C11.2595 5.03946 11.4208 4.96043 11.6297 5.01791C11.9815 5.1113 12.1171 5.52078 11.8862 5.79736C11.8569 5.83328 11.8239 5.86561 11.7873 5.89793C10.4716 7.18385 9.15955 8.47337 7.84018 9.75928C7.74122 9.85627 7.60929 9.92092 7.49567 9.99995H7.30876H7.3051Z",
    fill: "#34C759"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1283_1571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1283_1571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 5,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.40671a0a44f21ac2b5ce5b82b1e2b6d0.svg";
export { ForwardRef as ReactComponent };